module.exports = __webpack_public_path__ + "static/media/Ghostcity1.e9832f24.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Images/Environments/Ghostcity1.jpg
// module id = 207
// module chunks = 0